import { render } from "./FormView.vue?vue&type=template&id=8bd84bf4&scoped=true"
import script from "./FormView.vue?vue&type=script&lang=js"
export * from "./FormView.vue?vue&type=script&lang=js"

import "./FormView.vue?vue&type=style&index=0&id=8bd84bf4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd84bf4"]])

export default __exports__